(function () {
  const debounce = (fn, ms) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), ms);
    };
  };

  function init(form) {
    const input = form.querySelector('input[name="q"]');
    const drop = form.querySelector('.inkd-ps');
    if (!input || !drop) return;

    const sectionId = 'inkd-predictive-search';
    const limit = 4;

    const close = () => {
      drop.hidden = true;
      drop.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    };

    const open = (html) => {
      drop.hidden = false;
      drop.innerHTML = html;
      input.setAttribute('aria-expanded', 'true');
    };

    const fetchResults = async (q) => {
      const qs = new URLSearchParams();
      qs.set('q', q);
      qs.set('section_id', sectionId);
      qs.set('resources[type]', 'product');
      qs.set('resources[limit]', String(limit));

      const url = `${window.Shopify?.routes?.root || '/'}search/suggest?${qs.toString()}`;

      const res = await fetch(url, {
        method: 'GET',
        headers: { 'Accept': 'text/html' },
        credentials: 'same-origin',
      });

      if (!res.ok) return close();

      const htmlText = await res.text();

      let html = htmlText;
      try {
        const parsed = JSON.parse(htmlText);
        html = parsed[sectionId] || '';
      } catch (e) {}
      if (!html || html.trim().length < 5) return close();
      open(html);
    };

    const onInput = debounce(() => {
      const q = input.value.trim();
      if (q.length < 2) return close();
      fetchResults(q);
    }, 150);

    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-expanded', 'false');

    input.addEventListener('input', onInput);
    input.addEventListener('focus', () => {
      const q = input.value.trim();
      if (q.length >= 2) fetchResults(q);
    });

    document.addEventListener('click', (e) => {
      if (!form.contains(e.target)) close();
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });

    form.addEventListener('submit', () => close());
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('form[data-search]').forEach(init);
  });
})();
